<div class="width-1100">
  <mat-card>
    <div style='margin:auto; border-radius:10px;'>
      <img style='max-width: 200px; border-radius:10px;' src='assets/images/geral/mini_logo.png'>
    </div>
  </mat-card>

  <div *ngIf="current">

    <mat-card>
      <div class="collect-data">
        <span>{{current.member_name}}</span>
        <span>{{current.member_cpf}}</span>
      </div>
    </mat-card>


    <mat-card *ngIf="current.status === '3'">
      Esta solicitação já foi atendida.
    </mat-card>

    <div *ngIf="current.status !== '3'">

      <mat-card>
        <!-- TABLE -->
        <mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef>
              Anuidades em aberto
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="table-data">
                <span>
                  {{ element.product_name }}
                </span>
                <span>
                  <i>{{ element.category_name }}</i>
                </span>
                <span>
                  <b>{{ element.price | currency:'BRL':'':'1.2-2' }} </b>
                </span>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->
      </mat-card>

      <mat-card>
        <p *ngIf="current.qtd === 1">
          Existe uma anuidade em aberto no valor de <b>R$ {{current.value | currency:'BRL':'':'1.2-2' }}</b>.
        </p>

        <p *ngIf="current.qtd > 1">
          Existem {{current.qtd}} anuidades em aberto no valor total de <b>R$ {{current.value |
            currency:'BRL':'':'1.2-2'
            }}</b>.
        </p>
      </mat-card>

      <mat-card *ngIf="current.status !== '2'">

        <div>
          IMPORTANTE: <br>
          Após sua criação o PIX será válido por 24 horas.
        </div>
        <br>
        <button color='primary' (click)='createPIX()' mat-raised-button style="margin: auto;">
          Pagar com PIX
        </button>

        <p>
          Assim que o pagamento for identificado, enviaremos uma confirmação para o email: {{current.member_email}}.
        </p>

        <p>
          Obrigado!
          <br>
          Equipe SBCCV
        </p>

      </mat-card>

      <div *ngIf="current && current.status === '2'">
        <mat-card *ngIf="qrcodeImage">
          <div *ngIf="ReceivedDate">
           <b>PIX gerado em {{ReceivedDate.day}} às {{ReceivedDate.time}} h.</b>
          </div>
          <br>
          <div>
            <b>IMPORTANTE: <br>
              Este PIX é válido por 24 horas.</b>
          </div>
          <br>
          <div>Após o pagamento enviaremos um e-mail confirmando a operação.</div>
          <br>
          <img style="width: 200px" [src]="qrcodeImage" />
          <div
            style="margin-top: 30px; overflow-wrap: break-word; padding: 5px; text-wrap: wrap; border: solid 1px silver; border-radius: 5px;">
            {{qrcodeString}}
          </div>
          <div style="margin-top: 10px;">
            <a mat-button color="primary" (click)="copyToClipboard(qrcodeString)" style='width:60px; margin-left:10px;'>
              <mat-icon>content_copy</mat-icon>
              Copiar Código PIX
            </a>
          </div>
        </mat-card>
        <mat-card>
          <button color='primary' (click)='createPIX()' mat-raised-button style="margin: auto;">
            Gerar novo PIX
          </button>
        </mat-card>

      </div>

    </div>
  </div>



</div>